module.exports = __webpack_public_path__ + "img/agreement.a07eeaab.svg";